import styled from 'styled-components';

export const FormWrapper = styled.div`
	margin: ${(props) => props.theme.spacing['1_5']} 0;
`;
